import React, { useCallback, useEffect, useState } from 'react';
import { GridContainer, Grid } from '../../../shared/grid';
import { Formik, Form } from 'formik';
import { SelectChangeEvent } from '@mui/material/Select';
import { Autocomplete, ListItemText, TextField } from '@mui/material';
import { errorResponse, formatPhoneNumber, validateCharactersLength, validateCharacters, ValidCharacters } from '../../../store/common';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import '../FieldSample.scss';
import * as Yup from 'yup';
import { AreaContact } from 'src/types';
import { getArea, getContactsCall } from 'src/apis/getFuelSampleCalls';
import { useAddAlert } from 'src/store/actions';
import { createUpdateArea } from 'src/apis/mutationsFuelSample';
import { useStoreContext } from 'src/store/context';
import { useHistory } from 'react-router-dom';
import { ROUTE_PATHS } from 'src/routes';
import { alertMessages } from 'src/constants';

export const validationSchema = Yup.object().shape(
    {
        areaName: Yup.string().nullable()
          .required('Area Name is Required'),
        areaId: Yup.string()
          .required('Area Abbreviation is Required'),
        contacts: Yup.array().of(
          Yup.object().shape({
            contactName: Yup.string().nullable()
              .required('Contact Name is Required'),
              contactId: Yup.number().required()
          })
        )?.unique(alertMessages.saveAreaContact, 'contactId')?.required('Must have Contacts'),

    }
);

type AreaProps ={
  setOpen: any,
  setCreateUpdateAreaSuccess: any,
  editArea?: any,
}
interface FormVals {
  areaId: string,
  areaName: string,
  contacts: Array<AreaContact>;
  deleteContacts: Array<AreaContact>|null
}
export const Area: React.FC<AreaProps> = ({setOpen,setCreateUpdateAreaSuccess, editArea}) =>{
  const [, setCallComplete] = useState<boolean>(true);
  const [ areaFailureCount, setAreaFailureCount] = useState(0);
  const [contacts, setContacts] = useState<any[]>([]);
  const [contactFailureCount, setContactFailureCount] = useState(0);
  const history = useHistory();

  const [, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);

  const [initVals, setInitVals] = useState<FormVals>({
    areaId: '',
    areaName: '',
    contacts:[{
      contactName: '',
      contactPhone: '',
      contactExtension: '',
      title: '',
      contactEmail: '',
      priority: 1,
      contactId: 0,
      areaId: '',
    }],  
    deleteContacts:[]
  })

  const handleSubmit= (values:any)=>{
    (async()=>{
      try{
        let areaContacts: AreaContact[] = [];
        let deleteAreaContacts: AreaContact[] = [];

        for(const contact of values.contacts) {
          const areaContact: AreaContact = {
            areaContactId: contact.areaContactId,
            contactId: contact.contactId,
            priority: contact.priority,
            areaId: values.areaId,
          }
          areaContacts.push(areaContact);
        }

        const filteredContacts = values.deleteContacts?.filter(deleteContact => 
          !areaContacts?.some(contactToAdd => contactToAdd.contactId === deleteContact.contactId)
        );
        for(const deleteContact of filteredContacts) {
          const deleteAreaContact: AreaContact = {
            areaContactId: deleteContact.areaContactId,
            areaId: deleteContact.areaId,
            contactId: deleteContact.contactId,
            priority: deleteContact.priority,
          }
          deleteAreaContacts.push(deleteAreaContact)
        }

        let count =0;
        const contactsMoved = areaContacts?.map((contact)=>{
          const matchingObj = values.deleteContacts?.find(deleteContact => deleteContact.contactId === contact.contactId);
          if(matchingObj!==undefined){
            count=count+1;
          }
          return typeof matchingObj !=='undefined'? { ...contact, areaContactId: matchingObj?.areaContactId } : contact;
        });


        const params = {
          areaId: values.areaId,
          areaName: values.areaName,
          areaContacts: count>0? contactsMoved:areaContacts,
          deleteAreaContacts: filteredContacts?.length<=0? null: deleteAreaContacts,
          editArea: editArea? editArea:null
        };
        const responseFromUpdate:any = await createUpdateArea(null, addAlert, params);
        if(responseFromUpdate){
          setCreateUpdateAreaSuccess(true);
          setOpen(false);
        }
        else{
          console.log('error')
          errorResponse(responseFromUpdate, addAlert, alertMessages.saveArea);
        }
      }
      catch(error:any){
        console.log('error', error);
        if(error?.message){
          errorResponse(error, addAlert, alertMessages.saveArea);
        }
        else{
          let errorMsg = error[0].message;
          if(errorMsg.includes("Duplicate contact cannot be added to Area")){
            errorResponse(error, addAlert, alertMessages.saveAreaContact);
          }  
          else if(errorMsg.includes("Please enter a unique Area Name.")){
            errorResponse(error, addAlert,errorMsg);
          }
          else {
            errorResponse(error, addAlert, alertMessages.saveArea);
          }
        }
      }
    })();
  }
  /** Make an API call to populate the initVals when editing an area */
  const getAreaCall = useCallback((request: any, areaId: any) => {
    (async () => {
      try {
        const area: any = await getArea(request, areaId);
        const contacts: AreaContact[] = [];
        if(area && area[0]){
          for(const aContact of area[0].areaContacts) {
            const contact: AreaContact = {
              areaId: area[0].areaId,
              contactName: aContact.contact.name,
              contactPhone: aContact.contact.phoneNumber,
              contactExtension: aContact.contact.extension,
              title: aContact.contact.title,
              contactEmail: aContact.contact.email,
              priority: aContact.priority,
              contactId: aContact.contact.contactId,
              areaContactId: aContact.areaContactId
            }
            contacts.push(contact);
          }
          const sortedContacts = contacts? [...contacts].sort((a, b) => (a.priority && b.priority && a.priority > b.priority  ? 1 : -1)): contacts
          const areaToEdit: FormVals = {
            areaId: area[0].areaId,
            areaName: area[0].areaName,
            contacts: sortedContacts,
            deleteContacts:[]
          }
          setInitVals(areaToEdit);
        }
      } catch (error) {
        errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
      }
    })();
  }, [addAlert]);

  /* use Effect to check and make a call to get the edit area */
  useEffect(()=>{
    if(editArea){
      
      const requestAreaReq = {
        setCallComplete: setCallComplete,
        addAlert: addAlert,
        token: null,
        setAreaFailureCount: setAreaFailureCount,
        areaFailureCount: areaFailureCount
      }
      getAreaCall(requestAreaReq, editArea.areaId)
    }
    else{
      let initValues={
        areaId: '',
        areaName: '',
        contacts:[{
          contactName: '',
          contactPhone: '',
          contactExtension: '',
          title: '',
          contactEmail: '',
          priority: 1,
          contactId: 0,
          areaId: ''
        }],  
        deleteContacts: []
      }
      setInitVals(initValues);
    }
  },[addAlert, areaFailureCount, editArea, getAreaCall]);

  /** Make an API call to get all contacts */
  const getContacts = useCallback((request: any) => {
    (async () => {
      try {
        const contactsPromise: any = await getContactsCall(request);
        setCallComplete(true);
        setContacts(contactsPromise?.contacts);
      } catch (error) {
        setContactFailureCount(contactFailureCount + 1)
      }
    })();
  }, [setCallComplete, setContacts, contactFailureCount, setContactFailureCount]);

    /** Set Contacts */
    useEffect(() => {
      if(contacts.length <= 0 && contactFailureCount <= 2) {
        const requestContactReq = {
          setContactCallComplete: setCallComplete,
          addAlert: useAddAlert,
          setContactFailureCount: setContactFailureCount,
          contactFailureCount: contactFailureCount,
          returnAll: true, 
          page: null,
          perPage: null
        };
        getContacts(requestContactReq);    
      }
    }, [contacts, getContacts, setContactFailureCount, contactFailureCount]);
  
  return(
  <GridContainer className="removePadding smooth-scrollbar" style={{height: '85%', maxHeight: '95%', overflowX: 'hidden', paddingBottom: '2rem'}}>
    <Grid row gap="md" className='page-heading'>
      <Grid
        desktop={{col:12}}
        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
          {
            editArea ? (
              <span className="font-sans-lg text-bold">Edit Area</span>
            ):(
              <span className="font-sans-lg text-bold">Add a New Area</span>
            )
          }
      </Grid>
    </Grid>
    <hr style={{width: '100%', marginBottom: '2rem', marginTop: '2rem'}}></hr>

    <Formik
      initialValues={initVals}
      validateOnBlur={true}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => handleSubmit(values) }>
      {({
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        handleBlur,
        isValid,
        setFieldTouched
      }) => { 
        
        const validateNames = (event: any) => {
          validateCharactersLength(event, 100);
        }
        
        const validateAbbreviations = (event: any) => {
          validateCharacters(event, ValidCharacters.Alpha, ValidCharacters.Numeric);
          validateCharactersLength(event, 100);
        }

        const setAreaName=(event: SelectChangeEvent)=>{
          setFieldTouched('areaName');
          if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
            return
          }
          setFieldValue('areaName', event.target.value);
        }

        const setAreaId=(event: SelectChangeEvent)=>{
          setFieldTouched('areaId');
          if(event.target.value.length ===1 && /^\s/.test(event.target.value)){
            return
          }
          setFieldValue('areaId', event.target.value);
        }

        const setContactName =( index: number, newValue: any) =>{
          if(values.contacts[index].areaContactId && values.deleteContacts) {
            const deleteContacts = [...values.deleteContacts];
            deleteContacts.push(values.contacts[index]);
            setFieldValue('deleteContacts', deleteContacts);
          }
          
          setFieldTouched(`contacts[${index}]`);
          if(!newValue) {
            const contact = {
              contactName: '',
              contactPhone: '',
              contactExtension: '',
              title: '',
              contactEmail: '',
              priority: index,
              contactId: 0
            }
            setFieldValue(`contacts[${index}]`, contact);
          } 
          else {
            const updatedContact = {
              contactName: newValue.contactName,
              contactPhone: newValue.contactPhone,
              contactExtension: newValue.contactExtension,
              title: newValue.title,
              contactEmail: newValue.contactEmail,
              priority: index + 1,
              contactId: newValue.contactId
            }
            setFieldValue(`contacts[${index}]`, updatedContact);
          }
        };
        
        const addNewContact = (contactsLength: number) =>{
          const newContact = {
            contactName: '',
            contactPhone: '',
            contactExtension: '',
            title: '',
            contactEmail: '',
            priority: contactsLength+1,
            contactId: contactsLength
          }
          setFieldValue('contacts', [...values.contacts, newContact])
        }

        const removeContact = (index: number) =>{
          if(values.contacts[index].areaContactId && values.deleteContacts) {
            const deleteContacts = [...values.deleteContacts];
            deleteContacts.push(values.contacts[index]);
            setFieldValue('deleteContacts', deleteContacts);
          }
          const updateContacts = [...values.contacts];
          updateContacts.splice(index,1);
          setFieldValue('contacts', updateContacts);
        }

        return(
          <Form onSubmit={handleSubmit}>
            <div className="paddingForm">
              {/* ****  'AREA NAME' INPUT FIELD  **** */}
              <Grid row desktop={{ col: 7 }}>
                <label id='createUpdateAreaName' htmlFor='createUpdateAreaName'>Area Name*</label>
                <TextField
                  value={values.areaName}
                  onBlur={handleBlur}
                  error={!!errors.areaName && !!touched.areaName}
                  onInput={(e) => validateNames(e)}
                  helperText={!!errors.areaName && !!touched.areaName ? errors.areaName : ''}
                  id='createUpdateAreaName'
                  type='string'
                  size='medium'
                  fullWidth
                  onChange={(e: any) => setAreaName(e)}
                  placeholder='Enter Area Name'
                />
              </Grid>
              {/* ****  'AREA ID' INPUT FIELD  **** */}

              <Grid row desktop={{ col: 7 }}>
                <label id='createUpdateAreaAbbreviation' htmlFor='createUpdateAreaAbbreviation'>Area Abbreviation*</label>
                <TextField
                  className={editArea && 'disabled-textfield'}
                  value={values.areaId}
                  onBlur={()=> setFieldTouched('areaId')}
                  error={!!errors.areaId && !!touched.areaId}
                  onInput={(e) => validateAbbreviations(e)}
                  helperText={errors.areaId && touched.areaId ? errors.areaId : ''}
                  id='createUpdateAreaAbbreviation'
                  type='string'
                  size='medium'
                  fullWidth
                  onChange={(e: any) => setAreaId(e)}
                  placeholder='Enter Area Abbreviation'
                />
              </Grid>
              {/* ****  SHOW/ITIRATE THRU 'CONTACTS'  **** */}
              {
                values.contacts?.map((contact, index)=>
                <div key={`${index}-${contact.contactName}`}>
                  {
                    index===0 && (
                      <>
                        <hr style={{width: '100%', marginBottom: '2rem', marginTop: '2rem'}}></hr>
                        <Grid row>
                          <span id='PrimaryContact' className='contactStyle'>Primary Contact</span>
                        </Grid>
                      </>
                    )
                  }
                  {
                    index>0 && (
                      <Grid row >
                        <Grid desktop={{col: 4}}>
                          <span id={`additionalContact ${index}`} className='contactStyle'>Additional Contact ({index+1})</span>
                        </Grid>
                        <Button variant="text" onClick={()=>removeContact(index)} style={{textTransform: 'none', textDecoration: 'underline', color: '#707070'}}>
                          <CloseIcon fontSize='small'/>
                          Remove
                        </Button>
                    </Grid>
                    )
                  }
                  
                  <Grid row gap='sm'>
                    <Grid desktop={{ col: 5 }}>
                      <label id={`createUpdateAreaContactName-${contact.contactId}-${index}`} htmlFor={`createUpdateAreaContactName-${contact.contactId}-${index}`}>Contact Name *</label>
                      <div className='searchAreas' style={{ width: '100%' }}>
                        <i className="fas fa-search" />
                        <Autocomplete
                          onBlur={handleBlur}
                          onChange={(event: any, newValue: any) => {
                            setContactName(index, newValue);
                          }}
                          id={`createUpdateAreaContactName-${contact.contactId}-${index}`}
                          style={{ width: '100%' }}
                          value={values.contacts[index]}
                          options={contacts}
                          getOptionLabel={(option)=>option.contactName}
                          renderOption={(props, item) => (
                            <li {...props} key={item.contactId}>
                              <ListItemText>{item.contactName}</ListItemText>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              placeholder='Search Names'
                              style={{ width: '100%' }}
                              onBlur={handleBlur}
                              error={!!errors.contacts && !!errors.contacts[index]
                                && !!touched.contacts && !!touched.contacts[index] 
                              }
                              helperText={!!errors.contacts && !!errors.contacts[index]
                                && !!touched.contacts && !!touched.contacts[index] ? (errors.contacts[index]['contactName'] ? errors.contacts[index]['contactName']:errors.contacts[index]['contactId'] ) :''
                              }
                              
                              {...params}
                              InputProps={{
                                ...params.InputProps,
                                type: 'search',
                              }}
                            />
                          )}
                        />
                      </div>
                      <div style={{marginTop: '-4%'}}>
                        <Button variant='text'  onClick={()=>history.push(`${ROUTE_PATHS.contacts}`)} style={{textTransform: 'none', textDecoration: 'underline', width: '75%'}}>Create New Contact<i className="fas fa-external-link-alt fa-2xs external-links" style={{paddingLeft: '2%', color:'#1a6ad3'}}/>
                        </Button>
                      </div>

                    </Grid>
                    <Grid desktop={{ col: 5 }} className="contactNumber">
                      <label id={`createUpdateAreaContactPhone-${contact.contactId}-${index}`} htmlFor={`createUpdateAreaContactPhone-${contact.contactId}-${index}`} className='disabled-label'>Government Phone</label>
                      <div className='contactPhone' style={{ width: '100%' }}>
                        <i className="fas fa-search" />
                        <TextField
                          className={'disabled-textfield'}
                          id={`createUpdateAreaContactPhone-${contact.contactId}-${index}`}
                          value={formatPhoneNumber(values.contacts[index].contactPhone)}
                          type='string'
                          onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                          size='medium'
                          fullWidth
                          placeholder='Government Phone'
                        />
                      </div>
                    </Grid>
                    <Grid desktop={{ col: 2 }} className="contactNumExt">
                      <label id={`createUpdateAreaContactExt-${contact.contactId}-${index}`} htmlFor={`createUpdateAreaContactExt-${contact.contactId}-${index}`} className='disabled-label'>Ext.</label>
                      
                      <TextField
                        className={'disabled-textfield'}
                        value={values.contacts[index].contactExtension}
                        id={`createUpdateAreaContactExt-${contact.contactId}-${index}`}
                        type='string'
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                        size='medium'
                        fullWidth
                        placeholder='Ext.'
                      />
                    </Grid>
                  </Grid>
                  
                  <Grid row gap='sm'>
                    <Grid desktop={{ col: 5 }}>
                      <label id={`createUpdateAreaContactEmail-${contact.contactId}-${index}`} htmlFor={`createUpdateAreaContactEmail-${contact.contactId}-${index}`} className='disabled-label'>Government Email</label>
                      <div className='contactPhone' style={{ width: '100%' }}>
                        <i className="fas fa-search" />
                        <TextField
                          className={'disabled-textfield'}
                          onBlur={handleBlur}
                          id={`createUpdateAreaContactEmail-${contact.contactId}-${index}`}
                          value={values.contacts[index].contactEmail}
                          type='string'
                          onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                          size='medium'
                          fullWidth
                          placeholder='Government Email'
                        />
                      </div>
                    </Grid>
                    <Grid desktop={{ col: 7 }} className="contactNumber">
                      <label id={`createUpdateAreaContactTitle-${contact.contactId}-${index}`} htmlFor={`createUpdateAreaContactTitle-${contact.contactId}-${index}`} className='disabled-label'>Position Title</label>
                      <div className='contactPhone' style={{ width: '100%' }}>

                        <i className="fas fa-search" />
                        <TextField
                          className={'disabled-textfield'}
                          value={values.contacts[index].title}
                          id={`createUpdateAreaContactTitle-${contact.contactId}-${index}`}
                          type='string'
                          onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                          size='medium'
                          fullWidth
                          placeholder='Position Title'
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <hr style={{width: '100%', marginBottom: '2rem', marginTop: '2rem'}}></hr>

                </div>
                )
              }

            <Grid row style={{marginBottom: '15%'}}>
              <Button variant="outlined" onClick={()=>addNewContact(values.contacts.length)}>
                <AddIcon fontSize='small'/>
                Add Contact
              </Button>
            </Grid>
            </div>

            <Grid row className='modalBottomDiv'>
              <Grid desktop={{col:10}} className="modalCancelDiv">
                <Button variant="outlined" style={{backgroundColor: 'white'}} onClick={()=>{setOpen(false)}}>
                  Cancel
                </Button>
              </Grid> 
              {
                editArea ? (
                  <Grid desktop={{col:2}} className='modalSubmitDiv'>
                    <Button variant="contained" type="submit" aria-disabled={!isValid}>
                      Save
                    </Button>
                  </Grid>
                ) : (
                  <Grid desktop={{col:2}} className='modalSubmitDiv'>
                    <Button variant="contained" type="submit" aria-disabled={!isValid}>
                      Add
                    </Button>
                  </Grid>
                )
              }
            </Grid>
          </Form>
      )}}
    </Formik>
  </GridContainer>
  )
}